import { render, staticRenderFns } from "./detailsActivity.vue?vue&type=template&id=09d5f628&scoped=true&"
import script from "./detailsActivity.vue?vue&type=script&lang=js&"
export * from "./detailsActivity.vue?vue&type=script&lang=js&"
import style0 from "./detailsActivity.vue?vue&type=style&index=0&id=09d5f628&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d5f628",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09d5f628')) {
      api.createRecord('09d5f628', component.options)
    } else {
      api.reload('09d5f628', component.options)
    }
    module.hot.accept("./detailsActivity.vue?vue&type=template&id=09d5f628&scoped=true&", function () {
      api.rerender('09d5f628', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/terminalActivity/detailsActivity.vue"
export default component.exports